import { Stack, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { messages } from '../messages'

export function BudgetUnauthorizedView() {
  return (
    <Stack space="$space-3" fluid>
      <Text variant="title1">
        <FormattedMessage {...messages.title} />
      </Text>
      <Text variant="body" tone="secondary">
        <FormattedMessage {...messages.unauthorized} />
      </Text>
    </Stack>
  )
}
